export default __webpack_public_path__ + "static/media/Presentatiton_3.a392d464.mp4";